import { render, staticRenderFns } from "./userSetting.vue?vue&type=template&id=2a540c95&scoped=true"
import script from "./userSetting.vue?vue&type=script&lang=js"
export * from "./userSetting.vue?vue&type=script&lang=js"
import style0 from "./userSetting.vue?vue&type=style&index=0&id=2a540c95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a540c95",
  null
  
)

export default component.exports